import { FC, useState } from 'react';
import cx from 'classnames';
import { ActionButtonProps } from '../ActionButton';
import { PopinProps } from '../Popin';
import * as SC from './styled';
import { Network } from './styled';
export type SharingAction = ActionButtonProps & {
  network: Network;
};
export type ShareButtonProps = ActionButtonProps & {
  className?: string;
  text: string;
  url: string;
  popinProps: PopinProps;
  sharingActions: SharingAction[];
};
const ShareButton: FC<ShareButtonProps> = props => {
  const {
    className,
    popinProps,
    sharingActions,
    ...rest
  } = props;
  const [isOpen, setIsOpen] = useState(false);
  return rest ? <SC.Container className={cx('ShareButton', className)}>
      <SC.Button {...rest} onClick={() => setIsOpen(true)} />
      <SC.StyledPopin title={rest?.label} htmlTitleTag="div" {...popinProps} isOpen={isOpen} closeHandler={() => setIsOpen(false)}>
        <SC.Actions>
          {sharingActions?.map((action, i) => <SC.Action target="_blank" rel="noopener noreferrer" ariaLabel={action.network} $network={action.network} {...action} key={i} />)}
        </SC.Actions>
      </SC.StyledPopin>
    </SC.Container> : null;
};
export default ShareButton;